import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "row"]

  add(event) {
    event.preventDefault()

    const index = this.rowTargets.length
    const html = this.templateTarget.innerHTML.replaceAll("__INDEX__", String(index))
    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()

    const row = event.target.closest("[data-provider-web-urls-target='row']")
    if (!row || this.rowTargets.length <= 1) return

    row.remove()
    this.reindex()
  }

  reindex() {
    this.rowTargets.forEach((row, index) => {
      row.querySelectorAll("[name*='[web_url]']").forEach((input) => {
        input.name = input.name.replace(/\[web_url\]\[\d+\]/, `[web_url][${index}]`)
      })
    })
  }
}
